import api from './api';

/**
 * سرویس گزارشات و آمار
 * شامل دریافت آمار کلی، گزارشات ملاقات‌ها، درآمد و غیره
 */

// دریافت آمار کلی
export const getOverviewStats = async (dateRange = 'month') => {
  try {
    const response = await api.get('/reports/overview', { 
      params: { dateRange } 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت آمار ملاقات‌ها
export const getAppointmentStats = async (dateRange = 'month') => {
  try {
    const response = await api.get('/reports/appointments', { 
      params: { dateRange } 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت آمار درآمد
export const getRevenueStats = async (dateRange = 'month') => {
  try {
    const response = await api.get('/reports/revenue', { 
      params: { dateRange } 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت آمار مشاوران
export const getConsultantStats = async (dateRange = 'month') => {
  try {
    const response = await api.get('/reports/consultants', { 
      params: { dateRange } 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت گزارش مشاور خاص
export const getConsultantReport = async (consultantId, dateRange = 'month') => {
  try {
    const response = await api.get(`/reports/consultants/${consultantId}`, { 
      params: { dateRange } 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت فعالیت‌های اخیر
export const getRecentActivity = async (limit = 10) => {
  try {
    const response = await api.get('/reports/activity', { 
      params: { limit } 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت گزارش کامل
export const getFullReport = async (params = {}) => {
  try {
    const response = await api.get('/reports/full', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}; 